/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-18 13:56:13
 * @LastEditTime: 2020-08-18 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/store/modules/domain.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getDomainData,
  createDomain,
  editDomain,
  getDomainInfo,
  deleteDomain
} from "@/service/domainService";
const domain = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取action列表
     */
    getDomainData(store, info) {
      return new Promise((resolve, reject) => {
        getDomainData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建action
     * @param {*} store
     * @param {*} data
     */
    createDomain(store, data) {
      return new Promise((resolve, reject) => {
        createDomain(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取action详情
     * @param {*} store
     * @param {*} id
     */
    getDomainInfo(store, id) {
      return new Promise((resolve, reject) => {
        getDomainInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑action
     * @param {*} store
     * @param {*} data
     */
    editDomain(store, data) {
      return new Promise((resolve, reject) => {
        editDomain(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除action
     * @param {*} store
     * @param {*} id
     */
    deleteDomain(store, id) {
      return new Promise((resolve, reject) => {
        deleteDomain(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default domain;



// WEBPACK FOOTER //
// ./src/store/modules/domain.js